export const License = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="2.8 4.8 24.4 20.4"
    >
      <mask id="path-1-inside-1_2583_9499" fill="white">
        <rect x="4" y="6" width="22" height="18" rx="1" />
      </mask>
      <rect
        x="4"
        y="6"
        width="22"
        height="18"
        rx="1"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinejoin="round"
        mask="url(#path-1-inside-1_2583_9499)"
      />
      <line
        x1="17"
        y1="13.4"
        x2="23"
        y2="13.4"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      <line
        x1="17"
        y1="17.4"
        x2="23"
        y2="17.4"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      <path
        d="M15 21V18.6667C15 18.6667 15 16 12.3333 16C9.66669 16 12.3333 16 9.66669 16C7.00003 16 7.00003 18.6667 7.00003 18.6667L7 21"
        fill="currentColor"
      />
      <path
        d="M11 15C12.6569 15 14 13.6569 14 12C14 10.3431 12.6569 9 11 9C9.34315 9 8 10.3431 8 12C8 13.6569 9.34315 15 11 15Z"
        fill="currentColor"
      />
    </svg>
  )
}
